import { useEffect, useState } from 'react'
import { Item } from '../../../common/snippets'
import { Box, Button, Checkbox, Stack, TableCell, TableRow } from '@mui/material'
import * as sx from '../../../common/stylesInline/report_daily_branch'
import DropDownOA from '../../../common/dropDownOA'
import { headers, selectChargeOpt } from './constants'
import { ewayBillDateFormat, focusElemnt, navigation3, removeDuplicatesFromArray } from '../../../common/helper'
import useToken from '../../../helpers/useTokens'
import { useAtom, useSetAtom } from 'jotai'
import { alertAtom, globalLoaderAtom, modalAtom } from '../../../common/jotaiState/globalStateAtoms'
import { GetRequest, PostRequestCachedV3 } from '../../../common/api'
import { API_CACHE_DURATION, urls } from '../../../common/constants'
import VirtualizedTable from '../../../common/virtualisedTable'
import { useTheme } from '@emotion/react'
import FilterAltIcon from '@mui/icons-material/FilterAlt'
import { CartageSetupModal } from './cartageModal'

export const PickupAndDropoffCartage = () => {
  const theme = useTheme()
  const { tableHeaderColor } = theme
  const { loginData } = useToken()
  const [modal, setModal] = useAtom(modalAtom)
  const [selectCharge, setSelectCharge] = useState(selectChargeOpt[0])
  const [tableData, setTableData] = useState([])
  const setLoader = useSetAtom(globalLoaderAtom)
  const setAlert = useSetAtom(alertAtom)
  const [isUpdate, setIsUpdate] = useState(false)
  const [allBranchList, setAllBranchList] = useState([])
  const [searchData, setSearchData] = useState({})
  const [filtered, setFiltered] = useState([])

  const getBranchList = () => {
    const obj = {
      intUserID: 0,
      intCompanyID: loginData?.intCompanyID,
      intBranchID: 0,
      strBranchName: '',
      strBranchCode: '',
      intStateID: 0,
      intCityID: 0,
      intIsActive: -1,
    }
    setLoader(true)
    PostRequestCachedV3(urls.getBranchConfigOrEwbillinfo, obj, true, API_CACHE_DURATION)
      .then((res) => {
        if (res.status !== 'Success') {
          throw new Error(res?.ErrMessage || 'Request Failed')
        }
        if (!Array.isArray(res.Data.Table)) {
          throw new Error('No Data Found')
        }
        setAllBranchList(res.Data.Table)
      })
      .catch((err) => {
        setAllBranchList([])
        setAlert({ show: true, msg: err.message, nextId: '' })
      })
      .finally(() => setLoader(false))
  }
  useEffect(() => {
    const filterData = tableData.filter((row) => {
      return Object.entries(searchData).every(([key, value]) => {
        if (value === '') return true
        const rowValue = row?.[key]
        return rowValue != null && rowValue.toString().toLowerCase().includes(value.toString().toLowerCase())
      })
    })
    setFiltered(filterData)
  }, [searchData, tableData])
  useEffect(() => {
    focusElemnt('Select_Cartage')
    getBranchList()
  }, [])
  useEffect(() => {}, [loginData])
  const handleSeach = () => {
    const data = {
      CompanyID: loginData.intCompanyID,
      BranchID: loginData.intBranchID,
      Mode: selectCharge?.id || 1,
    }
    setLoader(true)
    GetRequest(urls.getCargoPickupDropoffCartage, data)
      .then((res) => {
        if (res.status !== 'Success') {
          throw new Error(res?.ErrMessage || 'Request Failed')
        }
        if (!Array.isArray(res.Data.Table)) {
          throw new Error('No Data Found')
        }
        const list = res.Data.Table.map((item, index) => ({
          ...item,
          SN: index + 1,
          dataType: 'entry',
          Status: <Checkbox checked={item.IsActive === 1} sx={{ padding: 0 }} />,
          ModifiedDateTime: ewayBillDateFormat(item.ModifiedDateTime),
        }))
        setTableData(list)
      })
      .catch((err) => {
        setTableData([])
        setAlert({ show: true, msg: err.message, nextId: '' })
      })
      .finally(() => setLoader(false))
  }
  const branchIds = removeDuplicatesFromArray(tableData, 'BranchID').map((item) => item.BranchID)
  const closePopup = () => {
    setModal('')
    setIsUpdate(false)
  }
  const openPopup = () => {
    setModal('PickupAndDropoffModal')
  }
  const refreshData = () => {
    handleSeach()
    openPopup()
  }
  const handleSearchData = (event, field) => {
    setSearchData({ ...searchData, [field]: event.target.value.toString() })
  }
  const keyboardNavigation = (event, prevId, nextId) => {
    if (event.key === 'Escape') {
      focusElemnt(prevId)
    }
    if (event.key === 'Enter') {
      focusElemnt(nextId)
    }
  }
  const headerContent = () => {
    return (
      <>
        <TableRow>
          {headers.map((item) => {
            return (
              <TableCell
                style={{
                  backgroundColor: '#e5f3ff',
                  color: '#444',
                  fontSize: '12px',
                  lineHeight: '16px',
                  letterSpacing: '0.24px',
                  fontWeight: '600',
                  whiteSpace: 'pre-line',
                  padding: '6px 8px',
                  width: item.width,
                  textAlign: item.align || 'left',
                }}
                colSpan={1}
              >
                {item?.header}
              </TableCell>
            )
          })}
        </TableRow>
        <TableRow>
          {headers.map((col, index) =>
            col.showfilter ? (
              <TableCell key={`FTH-${index}`} sx={{ minHeight: '36px' }}>
                <div className="filter-input" style={{ fontSize: '12px', justifyContent: 'space-between' }}>
                  <input
                    id={`index-${index}`}
                    className="field"
                    name="cancelSearchInput"
                    style={{ width: '100%' }}
                    value={searchData[col.field]}
                    placeholder="Contains"
                    onChange={(e) => handleSearchData(e, col.field)}
                    onKeyDown={(e) =>
                      keyboardNavigation(
                        e,
                        index === 1 ? 'editExisting' : `index-${index - 1}`,
                        index === 9 ? 'Select_Charge' : `index-${index + 1}`
                      )
                    }
                  />
                  <FilterAltIcon sx={{ paddingRight: '0px !important' }} />
                </div>
              </TableCell>
            ) : (
              <TableCell></TableCell>
            )
          )}
        </TableRow>
      </>
    )
  }
  const DisPatchBody = ({ row, index, tableHeaderColor, columnDefs }) => {
    if (!row?.dataType) return null
    const getStyles = (field, align) => {
      const common = {
        minHeight: '36px',
        fontSize: '12px',
        color: '#444',
        padding: '6px 8px',
      }
      if (row.dataType === 'entry') {
        return {
          ...common,
          fontWeight: '500',
          textAlign: align || 'left',
          height: '36px',
        }
      }
      if (row.dataType === 'subHeader') {
        return {
          ...common,
          fontWeight: '600',
          backgroundColor: tableHeaderColor?.isSubHeadingColor,
          textAlign: row.align?.[field] || 'left',
          position: 'sticky',
          top: '94px',
        }
      }
      if (row.dataType === 'total') {
        return {
          ...common,
          fontWeight: '600',
          backgroundColor: tableHeaderColor?.isTotalColor,
          textAlign: row.align?.[field] || 'right',
        }
      }
    }

    return (
      <>
        {(() => {
          let skip = 0

          return columnDefs.map((item, i) => {
            if (skip > 0) {
              skip--
              return null
            }
            const colSpan = row.colSpan?.[item.field] || 1
            skip = colSpan - 1
            return (
              <TableCell className="reportTD" key={item.field + i + index} colSpan={colSpan} style={getStyles(item.field, item.align)}>
                {row[item.field]}
              </TableCell>
            )
          })
        })()}
      </>
    )
  }
  const bodyContent = (index, obj) => {
    return <DisPatchBody row={obj} index={index} tableHeaderColor={tableHeaderColor} columnDefs={headers} />
  }
  return (
    <>
      <Box sx={{ display: 'flex', justifyContent: 'start', alignItems: 'center', padding: '16px' }}>
        <Box sx={{ display: 'flex', gap: '16px' }} className="reportButtons">
          <Item sx={sx.itemsx}>
            <DropDownOA
              id={'Select_Company'}
              label={'Select Company'}
              data={[]}
              defaultvalue={loginData.strCompanyName || ''}
              idKey={`id`}
              dataKey={`name`}
              minWidth="250px"
              nextId={'search_btn'}
              prevId={`index-9`}
              disabled={true}
            />
          </Item>
          <Item sx={{ ...sx.itemsx, padding: 0 }} className="disabled-wrapper">
            <Button
              variant="contained"
              onKeyDown={(e) => navigation3(e, 'Select_Cartage', 'Select_Company', () => {})}
              id={'search_btn'}
              sx={{ width: '100%', paddingY: '6px !important' }}
              className="btn btn-primary"
              disabled={true}
            >
              Go
            </Button>
          </Item>
          <Item sx={sx.itemsx}>
            <DropDownOA
              id={'Select_Cartage'}
              label={'Select Cartage'}
              data={selectChargeOpt || []}
              defaultvalue={selectCharge?.name || ''}
              idKey={`id`}
              dataKey={`name`}
              onSelect={(val) => {
                setSelectCharge(val)
              }}
              minWidth="200px"
              nextId={'search_btn'}
              prevId={`index-9`}
            />
          </Item>
          <Item sx={{ ...sx.itemsx, padding: 0 }} className="disabled-wrapper">
            <Button
              variant="contained"
              onKeyDown={(e) => navigation3(e, 'add_btn', 'Select_Cartage', () => {})}
              id={'search_btn'}
              sx={{ width: '100%', paddingY: '6px !important' }}
              className="btn btn-primary"
              onClick={handleSeach}
            >
              SEARCH
            </Button>
          </Item>
          <Item sx={{ ...sx.itemsx }} className="disabled-wrapper">
            <Button
              variant="outlined"
              id={'add_btn'}
              sx={{ width: '100%' }}
              className="receiveitembtn"
              onKeyDown={(e) => navigation3(e, 'editExisting', 'search_btn', () => {})}
              onClick={() => {
                openPopup()
              }}
            >
              + ADD NEW
            </Button>
          </Item>
          <Item sx={{ ...sx.itemsx, padding: 0 }} className="disabled-wrapper">
            <Button
              variant="outlined"
              sx={{ width: '100%' }}
              id="editExisting"
              className="receiveitembtn"
              onKeyDown={(e) => navigation3(e, 'index-1', 'add_btn', () => {})}
              disabled={!tableData || tableData.length === 0}
              onClick={() => {
                setIsUpdate(true)
                openPopup()
              }}
            >
              EDIT EXISTING
            </Button>
          </Item>
        </Box>
      </Box>
      <Stack sx={{ marginLeft: 2, marginRight: 2, paddingTop: '10px', paddingBottom: '16px' }} className="vehicle-wise-table-box">
        <VirtualizedTable
          tableData={filtered}
          headerContent={headerContent}
          rowContent={bodyContent}
          tableStyle={{ tableLayout: 'auto', width: '100%' }}
          autoResize={true}
        />
      </Stack>

      {modal === 'PickupAndDropoffModal' && (
        <CartageSetupModal
          branchList={isUpdate ? allBranchList.filter((item) => branchIds.includes(item.BranchID)) : allBranchList}
          isUpdate={isUpdate}
          headText={`${isUpdate ? 'Edit' : 'Add'} Pickup / Dropoff Cartage`}
          refreshData={refreshData}
          closePopup={closePopup}
        />
      )}
    </>
  )
}
